export default __webpack_public_path__ + "static/media/fastSearchImg.f7b85047.svg";